export function useRecaptcha () {
  const code = process.env.VUE_APP_RECAPTCHA as string

  let script:HTMLScriptElement

  function addScript () {
    return new Promise((resolve, reject) => {
      script = document.createElement('script')

      script.src = `https://www.google.com/recaptcha/api.js?render=${code}&hl=en`

      document.body.appendChild(script)

      script.onload = () => {
        resolve(true)
      }
    })
  }

  async function execute (action = 'submit') {
    await addScript()

    console.log('action', code, action)

    return new Promise<string>((resolve, reject) => {
      window.grecaptcha.ready(async () => {
        const result = await window.grecaptcha.execute(code, {
          action
        })

        document.body.removeChild(script)

        return resolve(result)
      })
    })
  }

  return {
    code,
    execute
  }
}
